<template lang="pug">
  .page.page-game
    Game
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Game from '../containers/Game.vue';

export default {
  name: 'GamePage',
  props: {
  },
  data: () => {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile', 'isMusicPlayed']),
  },
  methods: {
    ...mapActions(['resetData', 'openPopup', 'toggleMusicPlayed']),
  },
  mounted() {
    const { resetData, isMusicPlayed, toggleMusicPlayed } = this;
    resetData();
    if (!isMusicPlayed) {
      if (this.isMobile) this.openPopup({ type: 'ring' })
      toggleMusicPlayed(true);
    }
  },
  components: {
    Game,
  }
}
</script>

<style lang="scss">

</style>
